export function NoBookingsIllustration() {
  return (
    <svg
      width="200"
      height="160"
      viewBox="0 0 200 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Calendar background */}
      <rect x="40" y="20" width="120" height="120" rx="8" fill="#F3F4F6" />
      <rect x="40" y="20" width="120" height="30" rx="8" fill="#E5E7EB" />

      {/* Calendar header dots */}
      <circle cx="60" cy="35" r="3" fill="#9CA3AF" />
      <circle cx="140" cy="35" r="3" fill="#9CA3AF" />

      {/* Calendar grid */}
      <line x1="55" y1="60" x2="145" y2="60" stroke="#D1D5DB" strokeWidth="1" />
      <line x1="55" y1="80" x2="145" y2="80" stroke="#D1D5DB" strokeWidth="1" />
      <line x1="55" y1="100" x2="145" y2="100" stroke="#D1D5DB" strokeWidth="1" />
      <line x1="55" y1="120" x2="145" y2="120" stroke="#D1D5DB" strokeWidth="1" />

      <line x1="75" y1="50" x2="75" y2="130" stroke="#D1D5DB" strokeWidth="1" />
      <line x1="95" y1="50" x2="95" y2="130" stroke="#D1D5DB" strokeWidth="1" />
      <line x1="115" y1="50" x2="115" y2="130" stroke="#D1D5DB" strokeWidth="1" />
      <line x1="135" y1="50" x2="135" y2="130" stroke="#D1D5DB" strokeWidth="1" />

      {/* Empty checkmark cross */}
      <circle cx="100" cy="95" r="20" fill="white" stroke="#E5E7EB" strokeWidth="2" />
      <path d="M90 95 L110 95 M100 85 L100 105" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
